import { makeStyles } from '@material-ui/styles'

export const useNoDataStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    justifyContent: 'center',
    padding: theme.spacing(1.5, 1),
    backgroundColor: theme.palette.loading.backgroundColor,
  },
  emptyIcon: {
    fontSize: `${theme.typography.pxToRem(16)} !important`,
    color: theme.palette.loading.iconColor,
  },
  emptyMessage: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.loading.color,
  },
}))
